import script from "./Lightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Lightbox.vue?vue&type=script&setup=true&lang=js"

import "./Lightbox.vue?vue&type=style&index=0&id=63e61368&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e61368"]])

export default __exports__